import { useState, useEffect } from 'react';
import { get, set, remove } from 'lodash';

import { getDefaultDictionaryValue, isWarehouseUsedMoreThanOne } from '../../utils';

export const FIELD_PATH = 'settings.inventory_warehouse_source_map';

export const useMSIFields = ({ dictionaries, formData, onChangeField }) => {
    const [msiMapError, setMsiMapError] = useState(false);

    useEffect(() => {
        setMsiMapError(
            isWarehouseUsedMoreThanOne({
                list: get(formData, FIELD_PATH, []),
                label: 'source_code',
            }),
        );
    }, [formData]);

    const handleAddPair = () => {
        const warehouseDictionaryDefaultValue = getDefaultDictionaryValue({
            dictionary: get(dictionaries, 'warehouses', []),
        });

        const sourceDictionaryDefaultValue = getDefaultDictionaryValue({
            dictionary: get(dictionaries, 'msiSources', []),
        });

        const warehouseSourceMap = get(formData, FIELD_PATH, []).concat({
            warehouse_id: warehouseDictionaryDefaultValue,
            source_code: sourceDictionaryDefaultValue,
        });

        onChangeField({
            name: FIELD_PATH,
            value: warehouseSourceMap,
        });
    };

    const handleRemovePair = (key) => {
        const warehouseSourceMap = remove(get(formData, FIELD_PATH, []), (value, index) => index !== key);

        onChangeField({
            name: FIELD_PATH,
            value: warehouseSourceMap,
        });
    };

    const handleChangeField = (key, fieldName, value) => {
        const warehouseSourceMap = get(formData, FIELD_PATH, []);
        set(warehouseSourceMap, `${key}.${fieldName}`, value);

        onChangeField({
            name: FIELD_PATH,
            value: warehouseSourceMap,
        });
    };

    return {
        msiMapError,
        handleAddPair,
        handleRemovePair,
        handleChangeField,
    };
};
